import React, { useEffect, useState } from "react";
import { Card, CardBody, CardExpandToggler } from "./../../components/card/card.jsx";
import Chart from "react-apexcharts";
import { apiUrl } from "../../config/config.js";
import { getChartOptions } from "../../components/dashboard/getChartOptions.js";
import MovementsLog from "../../components/dashboard/MovementsLog.jsx";

function Dashboard() {
	const [citasHoy, setCitasHoy] = useState(0);
	const [citasTotal, setCitasTotal] = useState(0);
	const [citasPendientes, setCitasPendientes] = useState(0);
	const [citasEstaSemana, setCitasEstaSemana] = useState(0);
	const [customersCounts, setCustomersCounts] = useState(0);
	const [sucursales, setSucursales] = useState(0);
	const [vehiculos, setVehiculos] = useState(0);
	const [vendedores, setVendedores] = useState(0);
	const [customerList, setCustomersList] = useState([]);
	const [ultimasCitas, setUltimasCitas] = useState([]);
	const [ventasPorMarca, setVentasPorMarca] = useState([]);
	const [statsData, setStatsData] = useState();
	const [chartOptions, setChartOptions] = useState(getChartOptions());

	useEffect(() => {
		fetchDashboardData();
	}, []);

	const fetchDashboardData = async () => {
		try {
			const response = await fetch(apiUrl + "/dashboardData", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (response.status === 200) {
				let data = await response.json();
				console.log("DASHBOARD DATA TESTING", data);
				
				// Usar la nueva estructura de datos
				const dashboardData = data.data;
				setCitasHoy(dashboardData.citasHoy || 0);
				setCitasTotal(dashboardData.citasTotal || 0);
				setCitasPendientes(dashboardData.citasPendientes || 0);
				setCitasEstaSemana(dashboardData.citasEstaSemana || 0);
				setCustomersCounts(dashboardData.clientes?.length || 0);
				setSucursales(dashboardData.sucursales || 0);
				setVehiculos(dashboardData.vehiculos || 0);
				setVendedores(dashboardData.vendedores || 0);
				setCustomersList(dashboardData.clientes || []);
				setUltimasCitas(dashboardData.ultimasCitas || []);
				setVentasPorMarca(dashboardData.ventasPorMarca || []);
			}
		} catch (error) {
			console.error("Error al realizar la solicitud:", error);
		}
	};

	useEffect(() => {
		fetch("/assets/data/dashboard/stats.json")
			.then((res) => res.json())
			.then((result) => {
				setStatsData(result);
			});
	}, []);

	const counts = {
		"CITAS HOY": citasHoy,
		"TOTAL DE CITAS": citasTotal,
		"CITAS PENDIENTES": citasPendientes,
		"NÚMERO DE CLIENTES": customersCounts,
		"SUCURSALES": sucursales,
		"VEHÍCULOS": vehiculos,
		"VENDEDORES": vendedores,
		"CITAS ESTA SEMANA": citasEstaSemana,
	};

	return (
		<div>
			<div className="row">
				{statsData &&
					statsData.length > 0 &&
					statsData.map((stat, index) => (
						<div className="col-xl-3 col-lg-6" key={index}>
							<Card className="mb-3">
								<CardBody>
									<div className="d-flex fw-bold small mb-3">
										<span className="flex-grow-1">{stat.title}</span>
										<CardExpandToggler />
									</div>
									<div className="row align-items-center mb-2">
										<div className="col-7">
											<h3 className="mb-0">{counts[stat.title]}</h3>
										</div>
										<div className="col-5">
											<div className="mt-n2">
												<Chart
													type={stat.chartType}
													height={stat.chartHeight}
													options={chartOptions[stat.chartType]}
													series={stat.chartData}
												/>
											</div>
										</div>
									</div>
								</CardBody>
							</Card>
						</div>
					))}
				<MovementsLog title={"ÚLTIMOS CLIENTES REGISTRADOS"} data={customerList} type={"customer"} />
				<MovementsLog title={"ÚLTIMAS CITAS PROGRAMADAS"} data={ultimasCitas} type={"appointment"} />
			</div>
		</div>
	);
}

export default Dashboard;
